import type { FieldErrors } from './fieldError'
import { toastBlocked } from './toast'

export type FormCheck = { errors: FieldErrors }

export function gateAdvance(check: FormCheck | null, advance: () => void): void {
  if (check && check.errors.size > 0) {
    toastBlocked()
    return
  }
  advance()
}
